import React from 'react';
import { Section, Field } from './ui/formkit';

function EmployeeInfo({ employee, handleChange }) {
  return (
    <div>
      <Section title="Identity" description="Legal name as it appears on documents.">
        <Field label="First name" required>
          <input name="firstName" value={employee.firstName || ''} onChange={handleChange} required />
        </Field>
        <Field label="Last name" required>
          <input name="lastName" value={employee.lastName || ''} onChange={handleChange} required />
        </Field>
        <Field label="Middle name" span={2}>
          <input name="middleName" value={employee.middleName || ''} onChange={handleChange} />
        </Field>
      </Section>

      <Section title="Role" description="Position and access level inside the workspace.">
        <Field label="Designation" required>
          <input name="designation" value={employee.designation || ''} onChange={handleChange} required />
        </Field>
        <Field label="Category" required>
          <input name="category" value={employee.category || ''} onChange={handleChange} required />
        </Field>
        <Field label="Access level">
          <select name="role" value={employee.role || ''} onChange={handleChange}>
            <option value="">Select access level</option>
            <option value="admin">Admin</option>
            <option value="employee">Employee</option>
            <option value="employer">Employer</option>
          </select>
        </Field>
        <Field label="Status">
          <select name="status" value={employee.status || ''} onChange={handleChange}>
            <option value="">Select status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </Field>
      </Section>

      <Section title="Employment" description="Work authorization and dates of service.">
        <Field label="Work auth" required>
          <input name="workAuth" value={employee.workAuth || ''} onChange={handleChange} required />
        </Field>
        <Field label="Quick-time code">
          <input name="guestCode" value={employee.guestCode || ''} onChange={handleChange} placeholder="Optional, legacy" />
          <span style={{
            marginTop: '4px',
            fontFamily: 'var(--font-sans)', fontSize: '12px',
            color: 'var(--muted-soft)', textTransform: 'none',
            letterSpacing: 0, fontWeight: 400,
          }}>
            {(employee.role || '').trim()
              ? 'With an access level set, an invite to set their password is emailed to the employee. They sign in with their email.'
              : 'No sign-in will be created. Select an access level to invite this employee.'}
          </span>
        </Field>
        <Field label="Start date">
          <input type="date" name="startDate" value={employee.startDate || ''} onChange={handleChange} />
        </Field>
        <Field label="End date">
          <input type="date" name="endDate" value={employee.endDate || ''} onChange={handleChange} />
        </Field>
      </Section>
    </div>
  );
}

export default EmployeeInfo;
